import { Column }  from 'devextreme-react/data-grid';
import mechanic from "../images/wrench.svg";
import tyres from "../images/tire-service.svg"
import { faExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FactoryMenuTable } from './FactoryMenuTable';
import dayjs from 'dayjs';
import greenIcon from "../images/iconActivo.svg";
import redIcon from "../images/iconInactivo.svg"
import { convertToLocalTime, getCaseStateIcon } from '../commonFunctions/commonFunctions';
import { useTranslation } from 'react-i18next';

function getServiceIcon(service){
    const lower = service.toLowerCase()
    switch(lower){
        case "mecánica":
            return <img height={24} src={mechanic} title={service} />;
        case "neumáticos":
            return <img height={24} src={tyres} title={service} />
        case "carrocería":
            return <i class="icon icon-car-door-rear icon-table" title={service}></i>
        case "lunas":
            return <i class="icon icon-windshield-crack icon-table" title={service}></i>
        case "recogida y entrega":
            return <i class="icon icon-car-rental icon-table" title={service}></i>
        default:
            return undefined
    }
}

function getSLAIcon(data){
    // const yellow = "#f2cd11";
    const red = "#AB4715"

    // if(data.factoryInteractionAllowed){
    //     return <FontAwesomeIcon title={"Se requiere acción en el caso en fábrica"} icon={faExclamation} color={red}/>
    // }
    // const maxFactoryWaitingHours = window.getConfig("FACTORY_WAITING_HOURS");
    // const exceedsFactoryWaitingTime = exceedsMaximunWaitingTime(data.lastFactoryActivityDate, maxFactoryWaitingHours);

    // if(data.newFactoryActivity && !exceedsFactoryWaitingTime){
    //    return <FontAwesomeIcon title={"Modificaciones en el caso en fábrica"} icon={faExclamation} color={red}/>
    // } 
    // if((data.state.toLowerCase() !== "cerrado" && data.state.toLowerCase() !== "no gestionado") && exceedsFactoryWaitingTime){
    //   return <FontAwesomeIcon title={`El caso lleva más de ${maxFactoryWaitingHours} horas sin cambios en fábrica`} icon={faExclamation} color={yellow}/>
    // }

    const exceedsScheduleWaitingTime = dayjs(new Date()).isAfter(dayjs(data.scheduleDate))
    const caseOpen = data.state.toLowerCase() !== "cerrado" && data.state.toLowerCase() !== "no gestionado"
    if(exceedsScheduleWaitingTime && caseOpen){
        return <FontAwesomeIcon title={`El caso supera la fecha de agenda`} icon={faExclamation} color={red}/>   
    }
    

    return <div></div>
}


function exceedsMaximunWaitingTime(lastInteraction, maxTime){
    if(!lastInteraction){
        return false;
    }
    return dayjs(new Date()).isAfter(dayjs(lastInteraction).add(maxTime, "hours"))
}

function renderCampaignStatusColumn(data)
{
    const src = data.value  === true ? greenIcon : redIcon;
    const title = data.value === true ? "Activa" : "Inactiva";
    return <div className='active-column-cell'><img width={20} src={src} title={title}/><span>{title}</span></div>
}

export function renderCaseStateColumn(stateId, stateDescription)
{
    let colorCode = getCaseStateIcon(stateId)
    return <div className='active-column-cell'><img width={20} src={colorCode} title={stateDescription}/><span>{stateDescription}</span></div>
}



export const Columnas = () => {
    const { t } = useTranslation();

    return ({
    "Casos":[
        <Column key={"cases-00"} width={"0.25rem"} dataField={"stateId"} caption={""} allowResizing={false} cellRender={()=><span></span>} className={"state-column"}></Column>,
        <Column key={"cases-0"} dataField="caseId" caption={t("CaseId")} cellRender={(data)=>{
            return(
                <div style={{display: "flex", justifyContent:"space-between"}}><div className={"case-state-flag"}></div> {getSLAIcon(data.data)}<span>{data.value}</span></div>
            )
        }}/>,
        <Column key={"cases-1"} width={"6%"}  dataField="plate" caption={t("CustomerId")} />,
        <Column key={"cases-2"} width={"17%"} dataField="customerName" caption={t("CustomerName")} />,
        <Column key={"cases-3"} dataField="entryChannel" caption={t("EntryChannel")} />,
        <Column key={"cases-4"} dataField="taxonomyLevel_1" caption={t("Level1")} />,
        <Column key={"cases-5"} dataField="taxonomyLevel_2" caption={t("Level2")} />,
        <Column key={"cases-6"} dataField="taxonomyLevel_3" caption={t("Level3")} />,
        <Column key={"cases-7"} dataField="taxonomyLevel_4" caption={t("Level4")} />,
        <Column key={"cases-8"} width={150} dataType="datetime" format="dd/MM/yyyy HH:mm" defaultSortOrder="desc" sortIndex={1} dataField="creationDate" caption={t("StartDate")} />,
        <Column key={"cases-9"} width={150}  dataType="date" format="dd/MM/yyyy HH:mm" dataField="closeDate" caption={t("EndDate")} />,
        // <Column key={"cases-10"} dataType="datetime" format="dd/MM/yyyy HH:mm" dataField="scheduleDate" caption="Fecha Agenda" />,
        <Column key={"cases-11"} dataType="datetime" format="dd/MM/yyyy HH:mm" dataField="slaCloseDate" caption="SLA"/>,
        <Column key={"cases-12"} dataField="user" caption={t("Agent")} />,
        <Column key={"cases-13"} dataField="state" caption={t("State")} cellRender={(data)=>renderCaseStateColumn(data.data.stateId, data.value)} />,
        // <Column key={"cases-14"} dataField="cataloguing" caption="Catalogación veh." />,
        // <Column key={"cases-15"} width={60} dataField={"premium"} caption="Premium" dataType={"string"}  alignment="center"  calculateDisplayValue={(data)=>data.premium === true? "Sí" :  data.premium === false ? "No" : "" }/>,
        <Column key={"cases-16"} dataField="blockedByUser" cellRender={(data) => {
            return (
                <div style={{ textAlign: 'center' }}>{data.value ? <i className="icon icon-button icon-lock-closed icon-red" title={`${t("CaseBlockedBy")} ${data.value ? data.value : t("User")}`} /> : <i className="icon icon-button icon-lock-open icon-black"/>}</div>
            )
        }
        } caption={t("Blocked")} />,
    ],
    "Talleres":
       [
        <Column key={"workshops-0"} visible={false} dataField="id" caption="Id" />,
        <Column key={"workshops-1"} width={80} dataField="externalId" caption="Id" />,
        <Column key={"workshops-2"} width={250} defaultSortOrder="asc" sortIndex={1} dataField="name" caption="Nome" />,
        <Column key={"workshops-3"} width={200} dataField="address" caption="Dirección" />,
        <Column key={"workshops-4"} dataField="city" caption="Ciudad" />,
        <Column key={"workshops-5"} width={120} dataField="province" caption="Provincia" />,
        <Column key={"workshops-6"} width={80} dataField="postalCode" caption="CP" />,
        <Column key={"workshops-7"} width={120} dataField="phone" caption="Teléfono" />,
        <Column key={"workshops-8"} minWidth={100} dataField="brands" caption="Marcas" />,
        <Column key={"workshops-9"} dataField="brandCategory" caption="Categoría marca" />,
        <Column key={"workshops-10"} dataField="networkCategory" caption="Categoría red" />,
        <Column key={"workshops-11"} dataField="note" caption="Notas" />,
        <Column key={"workshops-12"} alignment="center" dataField="services" caption="Serviços" 
            cellRender={(data)=> {
                return <div style={{ textAlign: 'center', alignItems:"center" }}>
                   {data.value.map(e=> getServiceIcon(e))}    
                    </div>
            }}
            />
        ],
        "Historico":[  
        <Column key={"historic-0"} width={"0.25rem"} dataField={"stateId"} caption={""} allowResizing={false} cellRender={()=><span></span>} className={"state-column"}></Column>,
        <Column key={"historic-1"} width={150} dataField="caseId" caption={t("CaseId")} />,
        <Column key={"historic-2"} dataField="entryChannel" caption={t("EntryChannel")} />,
        <Column key={"historic-3"} dataField="taxonomyLevel_1" caption={t("Level1")} />,
        <Column key={"historic-4"} dataField="taxonomyLevel_2" caption={t("Level2")} />,
        <Column key={"historic-5"} dataField="taxonomyLevel_3" caption={t("Level3")} />,
        <Column key={"historic-6"} dataField="taxonomyLevel_4" caption={t("Level4")} />,
        <Column key={"historic-7"} dataType="date" defaultSortOrder="desc" sortIndex={1} format="dd/MM/yyyy HH:mm" dataField="creationDate" caption={t("StartDate")} />,
        <Column key={"historic-8"} dataType="date" format="dd/MM/yyyy HH:mm" dataField="closeDate" caption={t("EndDate")} />,
        <Column key={"historic-9"} dataField="user" caption={t("Agent")} />,
        <Column key={"historic-10"} width={250} dataField="state" caption={t("State")} cellRender={(data)=>renderCaseStateColumn(data.data.stateId, data.value)} />],
    "Flotas":[
        <Column key={"vehicles-0"} visible={false} dataField="id" caption="Id" />,
        <Column key={"vehicles-1"} width={120} defaultSortOrder="asc" sortIndex={1} dataField="plate" caption="Placa" />,
        <Column key={"vehicles-2"} width={150} dataField="brand" caption="Marca" />,
        <Column key={"vehicles-3"} width={"32%"} dataField="model" caption="Modelo" />,
        // <Column key={"vehicles-4"} width={90} dataField="kilometrage" caption="Km" />,
        <Column key={"vehicles-4"} width={150} dataField="chassisNumber" caption="Chassi" />,
        <Column key={"vehicles-5"} width={90} dataField="customerId" caption="Id Cliente" />,
        <Column key={"vehicles-6"} width={90} dataField="customerName" caption="Cliente" />,
        
        // <Column key={"vehicles-5"} dataType="date" width={150}  format="dd/MM/yyyy" dataField="measurementDate" caption="Fecha de lectura" />,
        // <Column key={"vehicles-6"} width={150} dataField="customerName" caption="Nombre del cliente" />
    ],
    "Clientes":[
        <Column key={"customers-0"} visible={false} dataField="id" caption="Id" />,
        <Column key={"customers-1"} width={"10%"} dataField="customerCode" caption={t("CustomerId")} />,
        <Column key={"customers-2"} width={"25%"} defaultSortOrder="asc" sortIndex={1} dataField="customerName" caption={t("CustomerName")} />,
        <Column key={"customers-3"} dataField="phone" caption={t("Phone")} />,
        // <Column key={"customers-4"} dataField="dniNif" caption="DNI" />,
        // <Column key={"customers-5"} dataField="fax" caption="Fax" />,
        // <Column key={"customers-6"} dataField="gdprInformed" caption="Gdpr informado" />,
    ],
    "Itvs":[
        <Column key={"itv-0"} visible={false} dataField="id" caption="Id" />,
        <Column key={"itv-1"} width={"7%"} defaultSortOrder="asc" sortIndex={1} dataField="region" caption="Comunidad autonoma" />,
        <Column key={"itv-2"} width={"7%"} dataField="province" caption="Provincia" />,
        <Column key={"itv-3"} width={"12%"} dataField="city" caption="Ciudad" />,
        <Column key={"itv-4"} width={"25%"} dataField="address" caption="Dirección" />,
        <Column key={"itv-5"} width={"7%"}  dataField="postalCode" caption="Código postal" />,
        <Column key={"itv-6"} width={"7%"} dataField="phone" caption="Teléfono" />,
        <Column key={"itv-7"}  dataField="net" caption="Red" />,
        <Column key={"itv-8"} width={"7%"}  dataField="appointmentPhone" caption="Teléfono cita" />,
        <Column key={"itv-9"} alignment="center" width={60} dataField="url" caption="Url"  cellRender={(data) => {
            return (
                <div style={{ textAlign: 'center' }}>{data.value ? <a style={{color: "#000"}} href={data.value.trim()} target="_blank"> <i class="icon icon-link icon-table"></i> </a> : ""}</div>
            )
            }
        } />,
        <Column key={"itv-10"} width={120} dataField="concerted" caption="Concertado"/>
    ],
    "CasosFabrica":[  <Column key={"factory-0"} width={"10%"} dataField="expedient" calculateCellValue={(data)=>data.currentExpedient || data.expedient} caption="No. Caso" />,
    <Column sortIndex={1}  defaultSortOrder="desc" key={"factory-1"} width={"12%"} dataType="datetime" format="dd/MM/yyyy HH:mm" dataField="entryDate" caption="Fecha entrada" />,
    <Column allowSorting={false} key={"factory-2"} width={"12%"} dataType="datetime" format="dd/MM/yyyy HH:mm" dataField="closeDate" caption="Fecha cierre" />,
    <Column key={"factory-3"}  dataField="area" caption="Área" />,
    <Column allowSorting={false} key={"factory-4"}  dataField="process" caption="Proceso" />,
    <Column allowSorting={false} key={"factory-5"} width={"10%"} caption="Estado" dataField={"state"}/>,
    <Column allowSorting={false} key={"factory-6"} width={50} name={"addComment"} cellRender={(data)=>{
        return (
            <>
               <FactoryMenuTable data={data} id={data.data.processId}/>
            </>    
        )
    }}></Column>
],
"Campañas": [
    <Column key={"campaign-1"} width={"5%"} dataField={"caseId"} caption={t("CaseId")} />,
    <Column key={"campaign-2"} width={"5%"} dataField={"plate"} caption={t("CustomerId")}/>,
    <Column key={"campaign-3"} dataField={"customer"} caption={t("CustomerName")}/>,
    <Column key={"campaign-4"} dataField={"campaignName"} caption={t("CampaignName")}/>,
    <Column key={"campaign-5"} width={"10%"} dataField={"activeCampaign"} cellRender={renderCampaignStatusColumn} caption={t("CampaignState")}/>,
    <Column key={"campaign-6"} width={"10%"} dataField={"startDate"} calculateDisplayValue={(e)=>dayjs(convertToLocalTime(e.startDate)).format("DD/MM/YYYY HH:mm")} caption={t("StartDate")} dataType={"datetime"}/>,
    <Column key={"campaign-7"} width={"10%"} dataField={"endDate"} calculateDisplayValue={(e)=> e.endDate && dayjs(convertToLocalTime(e.endDate)).format("DD/MM/YYYY HH:mm")} caption={t("EndDate")} dataType={"datetime"}/>,
]
})
};

